import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[sharedFocusableElement]',
  standalone: true,
})
export class FocusableElementDirective implements OnInit {
  @Input() disabledFocus = false;
  @Output() enterPressed = new EventEmitter<void>();
  @Output() tabPressed = new EventEmitter<void>();
  @Output() shiftTabPressed = new EventEmitter<void>();
  @Output() arrowUpPressed = new EventEmitter<void>();
  @Output() arrowDownPressed = new EventEmitter<void>();
  @Output() arrowLeftPressed = new EventEmitter<void>();
  @Output() arrowRightPressed = new EventEmitter<void>();

  private _el = inject(ElementRef);
  private _renderer = inject(Renderer2);

  ngOnInit(): void {
    if (this.disabledFocus) {
      return;
    }
    this._setTabIndex();
    this._addClass();
  }

  private _setTabIndex(): void {
    this._renderer.setAttribute(this._el.nativeElement, 'tabindex', '0');
  }

  private _addClass(): void {
    this._renderer.addClass(this._el.nativeElement, 'focusable-element');
  }

  private _restoreFocus(): void {
    this._el.nativeElement.focus();
  }

  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (this.disabledFocus) {
      return;
    }

    switch (event.key) {
      case 'Enter':
        if (this.enterPressed.observed) {
          this.enterPressed.emit();
          event.preventDefault();
        }
        break;
      case 'Tab':
        if (event.shiftKey && this.shiftTabPressed.observed) {
          this.shiftTabPressed.emit();
          event.preventDefault();
        } else if (this.tabPressed.observed) {
          this.tabPressed.emit();
          event.preventDefault();
        }
        break;
      case 'ArrowUp':
        if (this.arrowUpPressed.observed) {
          this.arrowUpPressed.emit();
          event.preventDefault();
          this._restoreFocus();
        }
        break;
      case 'ArrowDown':
        if (this.arrowDownPressed.observed) {
          this.arrowDownPressed.emit();
          event.preventDefault();
          this._restoreFocus();
        }
        break;
      case 'ArrowLeft':
        if (this.arrowLeftPressed.observed) {
          this.arrowLeftPressed.emit();
          event.preventDefault();
          this._restoreFocus();
        }
        break;
      case 'ArrowRight':
        if (this.arrowRightPressed.observed) {
          this.arrowRightPressed.emit();
          event.preventDefault();
          this._restoreFocus();
        }
        break;
      default:
        break;
    }
  }
}
